/*Analytics*/
analytics.eventConfig.push(
    {
        "target": "div.bannerOverlay",
        "codeId": "a04",
        "events": [
            {
                "eventTarget": ".overlay-btn a:not([href*=\\https])",
                "eventType": "click",
                "tags": {
                    "componentId": "a04",
                    "componentName": "special screen title",
                    "destinationUrl": "",
                    "elementText": "",
                    "event": "navigation",
                    "eventType": "special screen title internal navigation click",
                    "elementType": "special screen title link",
                    "fileName": "",
                    "parentName": "special screen title",
                    "parentOrdinal": "",
                    "parentTitle": ""
                }
            },

        ]
    }
)